import drawImage from '@bilibili/generator-posters'

export default async ({ poster, avatar, userName, userRank, qrImg }) => {
  const nodeList = [
    {
      x: 0,
      y: 0,
      width: 750,
      height: 1437,
      label: 'image',
      value: poster,
    },

    {
      x: 71,
      y: 199,
      width: 99,
      height: 99,
      label: 'image',
      borderRadius: 49.5,
      value: avatar,
    },

    {
      x: 193,
      y: 202,
      width: 560,
      height: 32,
      lineHeight: 32,
      fontSize: 32,
      label: 'text',
      color: '#fff',
      text: userName,
    },

    {
      x: 193,
      y: 259,
      width: 544,
      height: 35,
      label: 'image',
      value: '//i0.hdslb.com/bfs/ogv/activity/film-history/share-txt.png',
    },

    {
      x: 290,
      y: 259,
      width: 180,
      height: 32,
      // label: 'rect',
      // backgroundColor: '#fff',
      align: 'center',
      lineHeight: 28,
      fontSize: 28,
      label: 'text',
      color: '#fff',
      text: userRank,
    },

    {
      x: 553,
      y: 1262,
      width: 140,
      height: 140,
      label: 'image',
      borderRadius: 8,
      value: qrImg,
    },
  ]

  return await drawImage([
    {
      width: 750,
      height: 1437,
      mode: 'nodeList',
      nodeList,
      imgType: 'url',
      scale: 1,
    },
  ])
}
